export class emailNotificationText{
    _id:any;
    notificationTextId:any;
    notificationTitle:any;
    notificationType:any;
    notificationTextDescription:any;
    status:any
}